import http from "./http_common";

class ShareCallServices {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }

  getUserName(data) {
    return http.get(`/patientAppointment/get-user-name?appointmentId=${data}`);
  }

  updateMedicalRecords(data) {
    return http.post(`patientHistoryAccess/save-from-invite-link`, data);
  }
  
}

export default new ShareCallServices();
